module.exports = __webpack_public_path__ + "static/TT-Floorplan-Floor18-c5923b99be6a56ad40d5213b5fdb987c.jpg";